import { render, staticRenderFns } from "./formlist.vue?vue&type=template&id=064b3639&scoped=true&"
import script from "./formlist.vue?vue&type=script&lang=js&"
export * from "./formlist.vue?vue&type=script&lang=js&"
import style0 from "./formlist.vue?vue&type=style&index=0&id=064b3639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b3639",
  null
  
)

export default component.exports